export const pathDashboard = "/dashboard";
export const pathAuth = "/auth";
